import { render, staticRenderFns } from "./CollapsibleCard.vue?vue&type=template&id=8bc4dcc2&"
import script from "./CollapsibleCard.vue?vue&type=script&lang=js&"
export * from "./CollapsibleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bc4dcc2')) {
      api.createRecord('8bc4dcc2', component.options)
    } else {
      api.reload('8bc4dcc2', component.options)
    }
    module.hot.accept("./CollapsibleCard.vue?vue&type=template&id=8bc4dcc2&", function () {
      api.rerender('8bc4dcc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/CollapsibleCard.vue"
export default component.exports